import React, { ReactElement, useCallback } from 'react';
import download from 'downloadjs';
import { EnhancedComponentProps, EnhancedComponentType, InjectedProps, WrappedComponentType } from '.';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const handleDownloadButtonClick = useCallback((url: string): void => {
      download(url);
    }, []);

    const injectedProps: InjectedProps = {
      onDownloadButtonClick: handleDownloadButtonClick,
    };

    return <Component {...props} {...injectedProps} />;
  };

  return WithContainer;
};
